import { createAction } from '@reduxjs/toolkit';
import { Part } from '../vehicles/actions';
import { Employee } from '../employee/actions';

export interface TaskBlocker {
    id: number;
    type: string;
    task: Task;
}

export interface Task {
    [key: string]: any;
    id?: number;
    name: string;
    hours?: string;
    parent_task?: number;
    assignee_id?: number;
    assignee?: Employee;
    assignees?: Employee[];
    payout?: number;
    due_date?: string;
    is_complete?: boolean;
    status?: string;
    priority?: string;
    dependencies?: Task[];
    blocked_by?: Task[];
    subtasks?: Task[];
    comments?: string[];
    parts?: Part[];
}

export const listTasksRequest = createAction<{filters: string, task_fields: string, excludes: string, vehicle_id?: number}>('tasks/listRequest');
export const listTasksSuccess = createAction<Task[]>('tasks/listSuccess');
export const listTasksFailure = createAction<string>('tasks/listFailure');

export const updateTasksRequest = createAction<{tasks: Task[], update_fields: string[], task_fields?: string, vehicle_id?: number, cb?: any}>('tasks/updateRequest');
export const updateTasksSuccess = createAction<{tasks: Task[], removed_tasks: number[]}>('tasks/updateSuccess');
export const updateTasksFailure = createAction<string>('tasks/updateFailure');

export const resetErrorRequest = createAction('tasks/resetErrorRequest');
